/**
 * Free-delivery-over-threshold discount.
 *
 * A single global, stateless rule — no per-user or per-code state to track —
 * so it's implemented as a pure function rather than a Firestore-backed
 * record. It maps onto the general Discount schema
 * (mzito-pay/src/interfaces/discount.interface.ts) as:
 *   { scope: "delivery_fee", type: "free", eligibility: { kind: "threshold", minSubtotal: FREE_DELIVERY_THRESHOLD } }
 */

export const FREE_DELIVERY_THRESHOLD = 2500; // KES subtotal at/above which delivery is free

/**
 * @param {number} subtotal - Cart subtotal (before delivery fee/service fee)
 * @param {number} calculatedDeliveryFee - Delivery fee before any discount
 * @returns {{
 *   deliveryFee: number,
 *   isFreeDelivery: boolean,
 *   originalDeliveryFee: number,
 *   amountToFreeDelivery: number
 * }}
 */
export function applyFreeDeliveryDiscount(subtotal, calculatedDeliveryFee) {
  const isFreeDelivery = subtotal >= FREE_DELIVERY_THRESHOLD;
  return {
    deliveryFee: isFreeDelivery ? 0 : calculatedDeliveryFee,
    isFreeDelivery,
    originalDeliveryFee: calculatedDeliveryFee,
    amountToFreeDelivery: isFreeDelivery ? 0 : FREE_DELIVERY_THRESHOLD - subtotal,
  };
}
